import { OPENAI_VERIFICATION_CONFIG } from './client';

export const getVerificationErrorMessage = (error: Error): string => {
  const message = error.message;
  if (
    message.includes('Failed to fetch') ||
    message.includes('NetworkError') ||
    message.includes('CORS')
  ) {
    return 'Verifica fallita: impossibile contattare il servizio remoto dal browser.';
  }
  if (
    !OPENAI_VERIFICATION_CONFIG.API_KEY ||
    message.includes('API key is not configured') ||
    message.includes('invalid_api_key') ||
    message.includes('Incorrect API key') ||
    message.includes('401')
  ) {
    return 'Verifica non disponibile: servizio esterno non configurato. Riavvia il dev server dopo aver aggiornato la configurazione.';
  }
  if (
    message.includes('OpenAI') ||
    message.includes('API error') ||
    message.includes('returned empty content')
  ) {
    return 'Verifica fallita: servizio esterno non disponibile.';
  }
  return message;
};
